const CareerPathwaysLoansLayout = <template>{{outlet}}</template>;

export default CareerPathwaysLoansLayout;
